import { styled } from "styled-components";

//문의 페이지 TextStyle
export const TextDiv24Style = styled.div`
  width: 100%;
  font-size: 24px;
  font-weight: 600;
  margin-left: 18px;
  display: flex;

  margin-top: 20px;
  margin-bottom: 20px;
`;
export const TextDiv18Style = styled.div`
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  margin-left: 18px;
  display: flex;

  margin-top: 15px;
  margin-bottom: 15px;
`;

export const LeftMargin = styled.div`
  margin-left: 300px;
`;
